var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMediaNode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "texteditor/media"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.9038 2.97501H7.63377L6.37377 1.75001L2.10375 1.75001C1.41075 1.75001 0.84375 2.30126 0.84375 2.97501L0.84375 10.675C0.84375 11.3488 1.41075 11.9 2.10375 11.9L11.9038 11.9C12.5968 11.9 13.1638 11.3488 13.1638 10.675V4.20001C13.1638 3.52626 12.5968 2.97501 11.9038 2.97501ZM11.9038 10.675L2.10375 10.675V2.97501L5.86977 2.97501L7.12977 4.20001H11.9038V10.675ZM10.9238 9.80001L8.40378 6.65001L6.30378 9.10001L4.55378 7.35001L2.80378 9.80001H10.9238ZM5.74377 5.46876C5.74377 4.97876 5.30277 4.55001 4.79877 4.55001C4.29477 4.55001 3.85377 4.97876 3.85377 5.46876C3.85377 5.95876 4.29477 6.38751 4.79877 6.38751C5.30277 6.38751 5.74377 5.95876 5.74377 5.46876Z",
    fill: "#01525E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaNode);
export default __webpack_public_path__ + "static/media/mediaNode.b5ac9394ffa61ee1010a10d49cd35cf6.svg";
export { ForwardRef as ReactComponent };